module.exports = __webpack_public_path__ + "staticVue/img/two.3efcf90f.png";